import {inject} from '@angular/core';
import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {UserProfileService} from "@shared/services/api/user-profile.service";

export const IntegrationsEnabledGuard: CanActivateFn = (): boolean | UrlTree => {
  const userProfileService = inject(UserProfileService);
  const router = inject(Router);
  return userProfileService.isIntegrationsEnabled() || router.createUrlTree(['/']);
};
